import React from "react";
import { Col, Button, Modal, Row } from "react-bootstrap";

export const AcceptLessonModal = ({ isOpen, onHide, Accept }) => {
  return (
    <div>
      <Modal
        size="lg"
        className="ProfileStatus-modal"
        show={isOpen}
        onHide={onHide}
      >
        <Modal.Body>
          <Row>
            <Col
              lg={12}
              md={12}
              sm={12}
              xs={12}
              style={{ padding: "10px 40px", textAlign: "justify" }}
            >
              <div
                className="cancel-btn flex-center-center"
                onClick={onHide}
                style={{
                  fontSize: "17px",
                  width: "30px",
                  height: "30px",
                  marginTop: "20px",
                }}
              >
                <i className="mdi mdi-close"></i>
              </div>
              <div style={{ marginBottom: "50px" }} />
              <h3>Accept Mawuli for weekly lessons ?</h3>
              <div className="modal-para" style={{ fontSize: "16px" }}>
                They would like to book weekly Maths (GCSE) to take place at the
                online classroom starting on Mon 14 May from 9:00AM - 10:00AM.
                Your earning for each lesson is £16.00
              </div>
              <div style={{ marginBottom: "30px" }} />

              <div style={{ marginBottom: "30px" }} />
              <div
                className="flex-between-center"
                style={{ marginTop: "30px" }}
              >
                <div
                  className="green-txt flex-center"
                  onClick={onHide}
                  style={{
                    width: "16px",
                    paddingBottom: "2px",
                    fontFamily: "CircularStdMedium, Arial, sans-serif",
                    fontSize: "16px",
                    fontWeight: "normal",
                    fontStretch: "normal",
                    fontStyle: "normal",
                    color: "#0f0f0f",
                    textDecoration: "underline",
                  }}
                >
                  Cancel
                </div>
                <Button
                  className="green-Button"
                  style={{
                    width: "126px",
                    height: "45px",
                    borderRadius: "5px",
                    fontFamily: "CircularStdMedium, Arial, sans-serif",
                    fontSize: "16px",
                    fontWeight: "normal",
                    fontStretch: "normal",
                    fontStyle: "normal",
                    color: "#ffffff",
                  }}
                  onClick={Accept}
                >
                  Accept
                </Button>
              </div>
            </Col>
          </Row>
        </Modal.Body>
      </Modal>
    </div>
  );
};
